import { render } from "./App.vue?vue&type=template&id=31bef5c6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=31bef5c6&lang=css"
script.render = render

export default script